import React from "react";
import websiteData from '../data.json';
import ScrollableAnchor from 'react-scrollable-anchor';
import CoverHeaderXs from '../components/header/cover-header-xs';
import SectionContainer from '../components/containers/section-container';
import Heading2Paragraph from '../components/titles/heading2-paragraph';
import CounterFeature from '../components/features/counter-feature';
import FeatureTabs from '../components/features/feature-tabs';
import ReactGA from 'react-ga';

export const initGA = () => {
    /* console.log('Ga init'); */
     ReactGA.initialize('UA-90162173-1'); 
}

export const logPageView = () => {
    /* console.log(window.location.pathname); */
    ReactGA.set({ page: window.location.pathname });
    ReactGA.pageview(window.location.pathname);
}

export default class AboutPage extends React.Component {
    componentDidMount() {
        initGA();
        logPageView();
    }
    render() {
        const aboutPage = websiteData.aboutPage,
              dataWebsiteData = aboutPage.CoverHeaderXs[0],
              dataAboutTitlePhilosophy = aboutPage.aboutTitlePhilosophy,
              dataAboutDevelopingInRomania = aboutPage.CounterFeature.aboutDevelopingInRomania,
              dataAboutDevelopingInRomaniaParagraph = aboutPage.CounterFeature.aboutDevelopingInRomaniaParagraph,
              dataFeatureRowItems = aboutPage.CounterFeature.featureRowItems,
              dataCarouselItems = aboutPage.CounterFeature.carouselItems,
              dataOurWork = aboutPage.FeatureTabs.ourWork,
              dataTabData = aboutPage.FeatureTabs.tabData;
        return (
            <div id="page">
                    <CoverHeaderXs backgroundImage={ dataWebsiteData.headerBackgroundImage } headerSizeClass={ dataWebsiteData.headerSizeClass } headerTitle={ dataWebsiteData.headerTitle } headerSubTitle={ dataWebsiteData.headerSubTitle }/>
                    <div className="gtco-section border-bottom">
                        <SectionContainer>
                            <ScrollableAnchor id={'gtco-history'}>
                                <Heading2Paragraph content={ { title: dataAboutTitlePhilosophy.title, paragraph: dataAboutTitlePhilosophy.paragraph } } />
                            </ScrollableAnchor>
                        </SectionContainer>
                    </div>
                    <div className="gtco-section">
                        <ScrollableAnchor id={'gtco-counter'}>
                            <CounterFeature content={ dataAboutDevelopingInRomania } text={ dataAboutDevelopingInRomaniaParagraph } featureRowItems={ dataFeatureRowItems } items={ dataCarouselItems }/>
                        </ScrollableAnchor>
                    </div> 
                    <div className="gtco-section gtco-subscribe services">
                        <ScrollableAnchor id={'our-work'}>
                            <FeatureTabs content={ dataOurWork } tabData={ dataTabData }/>
                        </ScrollableAnchor>   
                    </div>            
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/pages/about-page.js